export const smartbannerTranslation = {
    smartbanner: {
        label: "Continuez sur l'application {{app}}",
        open: 'Ouvrir',
    },
};
